export default "__VITE_ASSET__Blml7g5P__"